import { Button, Dialog, DialogActions, DialogContent, DialogHeader, ToastLevel, useIntl, useToast } from "@metsooutotec/modes-react-components"
import React, { FC, useState } from "react"
import { ProvisionEventEquipment } from "features/provisioning/provisions/models/provision-models"
import provisionEventStore from "features/provisioning/provisions/stores/provision-event-store"
import { NavigationDeleteEntityOptions } from "components/utils/modal-helper"
import { StoreResults } from "stores/stores-helper"

interface ProvisionEventsDeleteProps {
    isOpen: boolean | undefined
    onClose: (params: NavigationDeleteEntityOptions) => void
    entity?: ProvisionEventEquipment
}

const ProvisionEventDeleteModal: FC<ProvisionEventsDeleteProps> = ({ isOpen, onClose, entity }) => {
    const { formatMessage } = useIntl()
    const { setMessage } = useToast()
    const [isLoading, setLoading] = useState<boolean>(false)
    const [isError, setIsError] = useState<{ isError: boolean; errorMessage: string }>({ isError: false, errorMessage: "" })

    const header = `${formatMessage("provisionEvents.deleteModal.header")} "${entity?.description}".`
    const content = `${formatMessage("provisionEvents.deleteModal.content")}`

    const labels = {
        header,
        content,
    }
    const onConfirm = async (e: React.FormEvent): Promise<void> => {
        try {
            setLoading(true)

            let passed: boolean = false
            let message: string = ""

            let result: StoreResults = await provisionEventStore.delete(entity?.id as string)
            passed = result.passed
            message = result.message

            if (!passed) {
                setLoading(false)
                setIsError({ isError: true, errorMessage: message })
                return
            }

            setLoading(false)

            setMessage(`Provisioning Event "${entity?.description}" has been deleted!`, ToastLevel.SUCCESS, 6000)

            onClose({ deleted: false })
        } catch {
        } finally {
            setLoading(false)
        }
    }
    return (
        <>
            <Dialog open={isOpen} dimmer size='small' style={{ maxWidth: "696px" }}>
                <DialogHeader>{labels.header}</DialogHeader>
                {isError.isError && <p style={{ color: "red" }}>{isError.errorMessage}</p>}
                <DialogContent data-cy='dialog-content'>{labels.content}</DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={() => onClose({ deleted: false })} subtle={true}>
                        Cancel
                    </Button>
                    <Button disabled={isLoading} loading={isLoading} onClick={onConfirm} primary={true}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default ProvisionEventDeleteModal
